import { CLI_TEST_EXTENSION } from '../constants';

export function normalizePath(fileToTest: string) {
  const isStartWith =
    fileToTest.startsWith('./') || fileToTest.startsWith('/');
  return isStartWith ? fileToTest.trim() : `./${fileToTest.trim()}`;
}

export const checkHaveCli = (filepath?: string) => {
  if (!filepath) return false;
  return filepath.includes(CLI_TEST_EXTENSION);
};
